var $ = require("jquery");

module.exports = function (element) {

    element = $(element);

    var activeTab = null,
        firstTab = null,
        buttons = {},
        panels = {},
        tabFromUrl = location.hash.match(/([a-zA-Z0-9]+)/),
        hasMasonry = $('.js-masonry');

    element.find("[data-tab]").each(function(i, button) {
        button = $(button);
        buttons[button.data("tab")] = button;

        if (tabFromUrl) {

            if (tabFromUrl[1] == button.data("tab")) {
                firstTab = button.data("tab");
            }
            
        } else if (firstTab == null) {
            firstTab = button.data("tab");
        }

    });

    element.find("[data-tab-panel]").each(function(i, panel) {
        panel = $(panel);
        panel.hide();
        panels[panel.data("tab-panel")] = panel;
    });

    if (firstTab) {
        activate(firstTab);
    }

    element.on("click", "[data-tab]", function(ev) {
        ev.preventDefault();

        if (activeTab === $(this).data("tab")) {
            return; // Ne rien faire si d�j� s�lectionn�
        } else {
            activate($(this).data("tab"));

            updateHistory($(this).data("tab"));

            $('html, body').animate({
                scrollTop: $("#tab-group").offset().top - 80
            }, 600);

            // declenche masonry sinon affich� dans un tapon
            if (hasMasonry) {
                hasMasonry.masonry();
            }
        }
        
    });

    function activate(tabName) {
        if (activeTab == tabName) return;

        if (activeTab) {
            buttons[activeTab].removeClass("active");
            panels[activeTab].hide();
        }

        buttons[tabName].addClass("active");
        panels[tabName].show();
        activeTab = tabName;
    }

    function updateHistory(tabName) {

        if (history.replaceState) {
            history.replaceState(null, "", "#" + tabName);
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/controllers/tab-group.js
// module id = 247
// module chunks = 0